import { BadgeCheck, Crown } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { membershipActive } from "@/lib/constants";

const SIZES = { sm: "h-9 w-9 text-xs", md: "h-11 w-11 text-sm", lg: "h-16 w-16 text-lg", xl: "h-28 w-28 text-3xl" };

export const UserAvatar = ({ user, size = "md", className = "" }) => {
  const initials = (user?.full_name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  const src = mediaUrl(user?.avatar);
  return (
    <div className={`${SIZES[size]} shrink-0 overflow-hidden rounded-full bg-tm-green text-white grid place-items-center font-display font-bold ${className}`}>
      {src ? <img src={src} alt={user?.full_name} className="h-full w-full object-cover" referrerPolicy="no-referrer" /> : initials}
    </div>
  );
};

export const VerifiedTick = ({ user }) =>
  user?.verified ? <BadgeCheck className="h-4 w-4 shrink-0 text-tm-green-light" aria-label="Verified" data-testid="verified-badge" /> : null;

export const PlanBadge = ({ user }) => {
  if (!membershipActive(user)) return null;
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-tm-gold/15 px-2 py-0.5 text-[11px] font-semibold text-tm-green-light" data-testid="plan-badge">
      <Crown className="h-3 w-3" /> Member
    </span>
  );
};
